// src/components/Navbar.tsx
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/Navbar.css';
import logoImage from '../assets/logo.png';

const Navbar: React.FC = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        setMobileMenuOpen(false);
    }, [location]);

    useEffect(() => {
        // Check if user is logged in by checking for token
        const token = localStorage.getItem('token');
        setIsLoggedIn(!!token);

        // Listen for storage changes (in case user logs in/out in another tab)
        const handleStorageChange = () => {
            const token = localStorage.getItem('token');
            setIsLoggedIn(!!token);
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    const handleSignOut = () => {
        // Clear token and user data
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setIsLoggedIn(false);
        // Redirect to home page
        navigate('/');
    };

    return (
        <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
            <div className="nav-container">
                <Link to="/" className="logo">
                    <img src={logoImage} alt="EmpowerFuture21 Logo" className="logo-image" />
                    <div className="logo-text">Empower<span>Future21</span></div>
                </Link>

                <div className="mobile-menu-button" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <ul className={`nav-menu ${mobileMenuOpen ? 'open' : ''}`}>
                    <li><Link to="/" className={location.pathname === '/' ? 'active' : ''}>Home</Link></li>
                    <li><Link to="/what-we-do" className={location.pathname === '/what-we-do' ? 'active' : ''}>What We Do</Link></li>
                    <li><Link to="/activities" className={location.pathname.startsWith('/activities') ? 'active' : ''}>Our Work</Link></li>
                    <li><Link to="/careers" className={location.pathname.startsWith('/careers') ? 'active' : ''}>Careers</Link></li>
                    <li><Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>About</Link></li>
                    <li><Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''}>Contact</Link></li>
                </ul>

                {/* Minimized Sign In - separate from main navigation */}
                <div className="auth-section">
                    {isLoggedIn ? (
                        <div className="admin-dropdown">
                            <span className="admin-dropdown-toggle">
                                <i className="admin-icon-small">👤</i>
                            </span>
                            <ul className="admin-dropdown-menu">
                                <li>
                                    <Link to="/admin/activities" className="admin-menu-item">
                                        <i className="admin-icon">📊</i> Dashboard
                                    </Link>
                                </li>
                                <li>
                                    <button onClick={handleSignOut} className="admin-menu-item">
                                        <i className="admin-icon">🚪</i> Sign Out
                                    </button>
                                </li>
                            </ul>
                        </div>
                    ) : (
                        <Link to="/admin/login" className="sign-in-link" title="Admin Sign In">
                            🔒
                        </Link>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;